import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../../features/auth";
import type { ITransportNow } from "../../../models/storeModels/ITransportNow";
import { getItemWebStorage } from "../../../features/webStorageSaver";

function getInitialState(){
    const initialState: ITransportNow = {
        transportMonitoringObject: null,
        transportMonitoringBadgeShow: false,
        transportMonitoringFullList: null,
        transportMonitoringCheckReady: false,
        transportMonitoringShowNumbers: getItemWebStorage('transportMonitoringShowNumbers') ?? false,
        transportMonitoringHovered: null,
        transportMonitoringLastShownFeaturesJson: null
    }
    return initialState
}

export const transportNowSlice = createSlice({
    name: 'transportNow',
    initialState: getInitialState(),
    reducers: {
        setTransportMonitoringObject(state, action: PayloadAction<any>) {
            state.transportMonitoringObject = action.payload
        },
        setTransportMonitoringBadgeShow(state, action: PayloadAction<any>) {
            state.transportMonitoringBadgeShow = action.payload
        },
        setTransportMonitoringFullList(state, action: PayloadAction<any>) {
            state.transportMonitoringFullList = action.payload
        },
        setTransportMonitoringCheckReady(state, action: PayloadAction<any>) {
            state.transportMonitoringCheckReady = action.payload
        },
        setTransportMonitoringShowNumbers(state, action: PayloadAction<any>) {
            state.transportMonitoringShowNumbers = action.payload
        },
        setTransportMonitoringHovered(state, action: PayloadAction<any>) {
            state.transportMonitoringHovered = action.payload
        },
        setTransportMonitoringLastShownFeaturesJson(state, action: PayloadAction<any>) {
            state.transportMonitoringLastShownFeaturesJson = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const { setTransportMonitoringBadgeShow,
    setTransportMonitoringCheckReady,
    setTransportMonitoringFullList,
    setTransportMonitoringObject,
    setTransportMonitoringShowNumbers,
    setTransportMonitoringHovered,
    setTransportMonitoringLastShownFeaturesJson } = transportNowSlice.actions
export const transportNowReducer = transportNowSlice.reducer;
